module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Compass-999a3a0fe0d3fbc6d5ea8298ab273a0f.svg";